import React, { useContext, useEffect } from "react";
import FAQPanel from "../components/faq-panel/faq-panel.component";
import Layout from "../components/layout";
import LiveChat from "../components/live-chat/live-chat.component";
import FindYourBdm from "../components/find-your-bdm/find-your-bdm.component";
import GeneralAnchor from "../components/general-anchor/general-anchor.component";
import MoneyWorriesBtn from "../components/money-worries-btn/money-worries-btn.component";
import { MenuContext } from "../context";
import "../styles/app.scss";
import { Link } from "gatsby";
import { triggerTealiumEvent } from "../utils/tealiumUtils";
import { useLocation } from "@reach/router";
import NewWindow from "../assets/new_window.inline.svg";
import BDMFinder from "../components/bmd-finder/bdm-finder";
import LinkCard from "../components/info-card/link-card.component";

export default function BrokerSupport() {
  const menuContext = useContext(MenuContext);

  const location = useLocation();
  if (typeof window !== "undefined" && window.utag) {
    triggerTealiumEvent({
      tealiumEvent: "view",
      pageUrl: location.href,
      pageName: "broker support",
      pageType: "product information",
      pageSubCategory: "broker support",
      rawDataLayer: "10451v30",
    });
  }

  const handleClick = ({ sectionName, clickedText }) => {
    if (typeof window !== "undefined" && window.utag) {
      triggerTealiumEvent({
        tealiumEvent: "link",
        pageUrl: location.href,
        pageName: "broker support",
        eventCategory: "content",
        eventAction: "onsite",
        eventContent: `${sectionName} | broker support : ${clickedText}`,
        pageType: "product information",
        pageSubCategory: "broker support",
        rawDataLayer: "10451v33",
      });
    }
  };

  return (
    <>
      <Layout
        title="Broker support"
        metaDescription="Please refer to our Criteria page for all the information you will need on our lending policy, or for application updates please view case tracking on the broker platform."
      >
        <section className="broker-support-page row">
          <div className="information-container col-xs-12 col-lg-8">

            <h1 className="page-title">Broker support</h1>
            <p className="page-text">
              Please refer to the{" "}
              <Link className="inline-link" to="/criteria" inert={menuContext.isMenuOpen ? "true" : null}>
                Criteria
              </Link>{" "}
              page for our lending policy, for case tracking please see the Application platform dashboard.
            </p>
            <p className="page-text">If you require further assistance, there are various ways you can get in touch; via our Chat facility, telephone or your local BDM.</p>
            <p className="page-text">To help us to provide you with the best possible service, please ensure you contact us using one communication channel at any one time.</p>
            <p className="page-text">If you are experiencing issues with our application platform, please click{" "}
              <Link className="inline-link" to="/criteria/?p=Troubleshooting&tab=residential" inert={menuContext.isMenuOpen ? "true" : null}>
                here
              </Link>{" "}
              for further guidance.
            </p>
            <p className="page-text page-text--last">For detailed guidance and support with keying the application, please visit our{" "}
              <Link className="inline-link" to="/application-help-centre" inert={menuContext.isMenuOpen ? "true" : null}>
                Application Help Centre
              </Link>.
            </p>
            <div className="live-chat-wrapper">
              <LiveChat />
            </div>
            <section>
              <div className="affordability-calculator affordability-calculator--broker-support">
                <div className="affordability-calculator__buttons" style={{ paddingRight: "0" }}>
                  <h2 className="affordability-calculator__subtitle">Application and Registration Changes</h2>

                  <div className="accordion__body" style={{ padding: "0" }}>
                    <table style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th scope="col" bgcolor="#f0f0f0">What change is required?</th>
                          <th scope="col" bgcolor="#f0f0f0">Notes:</th>
                          <th scope="col" bgcolor="#f0f0f0">Submit request via:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <ul>
                              <li>Loan details – e.g. amount / term / purchase price</li>
                              <li>Extension to offer</li>
                            </ul>
                          </td>
                          <td>
                            <p>
                              For <strong>loan amount changes</strong> please refer to our guide{" "}
                              <a href="/criteria/?p=residential_Changestoborrowingorpurchaseprice&tab=residential"><strong>here</strong></a>{" "}
                              before submitting the request to prevent any delays
                            </p>
                          </td>
                          <td>
                            <ul>
                              <li>
                                <a href="/pdfs/ApplicationAmendmentForm-September2026.pdf" target="_blank" rel="noreferrer">
                                  Application amendment form
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <ul>
                              <li>Rate only</li>
                            </ul>
                          </td>
                          <td>
                            <p>
                              For <strong>rate only changes</strong> please refer to our guide{" "}
                              <a href="/pdfs/Product_change_table.pdf" target="_blank" rel="noreferrer"><strong>here</strong></a>{" "}
                              before submitting the request, as certain application types can be actioned via our
                              'Chat with us' service
                            </p>
                          </td>
                          <td>
                            <ul>
                              <li>
                                <a href="/pdfs/ApplicationAmendmentForm-September2026.pdf" target="_blank" rel="noreferrer">
                                  Application amendment form
                                </a>
                              </li>
                              <li>
                                <a href="https://www.hsbc.co.uk/mortgages/intermediaries/help/" target="_blank" rel="noreferrer">
                                  Chat with us
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <ul>
                              <li>Registration details</li>
                            </ul>
                          </td>
                          <td></td>
                          <td>
                            <ul>
                              <li>
                                <a href="/pdfs/Changes_to_your_registration_with_HSBC_UK.pdf" target="_blank" rel="noreferrer">
                                  Change to registration form
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <ul>
                              <li>Direct debit / solicitor / customer details</li>
                            </ul>
                          </td>
                          <td>
                            <p>
                              For personal detail changes, if the customer has any current HSBC products, they will
                              need to contact HSBC directly to amend their existing customer profile before we can
                              make any changes to their application.
                            </p>
                          </td>
                          <td>
                            <ul>
                              <li>Telephone – option 4</li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>


                </div>
              </div>
            </section>
          </div>
          <div className="support-container col-xs-12 col-lg-4">
            <BDMFinder />
            <LinkCard
              title="Need help with registering?"
              linkHref="/application-help-centre"
              theme="grey"
              colClass=""
              tealiumEventName="Need help with registering"
              tealiumPage="broker support"
            />
            <MoneyWorriesBtn />
            {/* <LatestNews newsItems={NewsData2023.rateChange} /> */}
            <FindYourBdm
              additionalClassname="green"
              onClick={(clickedText) =>
                handleClick({ sectionName: "accessibility and disability", clickedText: clickedText })
              }
            />
            <FAQPanel />
          </div>
        </section>
      </Layout>
    </>
  );
}
